
import { Box, Divider } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslate } from "src/locales";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzMuiRadioButton from "src/components/core-components/mui/buttons/ByzMuiRadioButton";
import ByzTitleAndInputBox from "src/components/core-components/ByzTitleAndInputBox/ByzTitleAndInputBox";

export const PregnancyInfoSection = () => {
  const { t } = useTranslate();
  const { control } = useFormContext();

  return (
    <Box
      sx={{
        border: "1px solid #DBDBDB",
        borderRadius: "4px",
        padding: "20px",
        width: "100%",
        marginTop: "20px",
      }}
    >
      <Grid container spacing={2}>
        <Grid md={2} xs={6}>
          <ByzTitleAndInputBox
            marginLeft="0px"
            title={t("child-patient-assessment.referral-location")}
          >
            <Controller
              name="pregnancyAndBirth.referralLocation"
              control={control}
              render={({ field }) => (
                <ByzMuiSelect
                  {...field}
                  options={[]}
                  label={t("open-process-menu.select", "capitalize")}
                  sx={{ pt: 1 }}
                />
              )}
            />
            <ByzTitleAndInputBox
              marginLeft="0px"
              sx={{ marginTop: "8px" }}
              title={t("description", "capitalize")}
            >
              <Controller
                name="pregnancyAndBirth.referralLocationDescription"
                control={control}
                render={({ field }) => (
                  <ByzMuiTextField {...field} multiline rows={2} sx={{ pt: 1 }} />
                )}
              />
            </ByzTitleAndInputBox>
          </ByzTitleAndInputBox>
        </Grid>

        <Grid md={2} xs={6}>
          <ByzTitleAndInputBox
            marginLeft="0px"
            title={t("child-patient-assessment.unit-arrival-method")}
          >
            <Controller
              name="pregnancyAndBirth.unitArrivalMethod"
              control={control}
              render={({ field }) => (
                <ByzMuiSelect
                  {...field}
                  options={[]}
                  label={t("open-process-menu.select", "capitalize")}
                  sx={{ pt: 1 }}
                />
              )}
            />
          </ByzTitleAndInputBox>
        </Grid>
        
        <Grid md={2} xs={6}>
          <ByzTitleAndInputBox
            marginLeft="0px"
            title={t("child-patient-assessment.pregnancy-type")}
          >
            <Controller
              name="pregnancyAndBirth.pregnancyType"
              control={control}
              render={({ field }) => (
                <ByzMuiTextField {...field} sx={{ pt: 1 }} />
              )}
            />
          </ByzTitleAndInputBox>
        </Grid>
        
        <Grid md={3} xs={6}>
          <ByzTitleAndInputBox
            marginLeft="0px"
            title={t("child-patient-assessment.reduction")}
          >
            <Controller
              name="pregnancyAndBirth.reduction"
              control={control}
              render={({ field }) => (
                <ByzMuiRadioButton
                  {...field}
                  typographyText="yes,no,unknown"
                  layout="row"
                  border="none"
                  fontSize={16}
                />
              )}
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid md={3} xs={6}>
          <ByzTitleAndInputBox
            marginLeft="0px"
            title={t("child-patient-assessment.multiple-pregnancy")}
          >
            <Controller
              name="pregnancyAndBirth.multiplePregnancy"
              control={control}
              render={({ field }) => (
                <ByzMuiRadioButton
                  {...field}
                  typographyText="yes,no,unknown"
                  layout="row"
                  border="none"
                  fontSize={16}
                />
              )}
            />
          </ByzTitleAndInputBox>
        </Grid>
      </Grid>

      <Divider sx={{ borderColor: "black", borderBottomWidth: "2px", my: 2 }} />

      <Grid container spacing={2}>
        {[
          { name: "pregnancyAndBirth.numberOfPregnancies", label: "child-patient-assessment.number-of-pregnancies" },
          { name: "pregnancyAndBirth.numberOfBirths", label: "child-patient-assessment.number-of-births" },
          { name: "pregnancyAndBirth.numberOfMiscarriages", label: "child-patient-assessment.number-of-miscarriages" },
          { name: "pregnancyAndBirth.numberOfLivingChildren", label: "child-patient-assessment.number-of-living-children" },
          { name: "pregnancyAndBirth.otherInfo", label: "child-patient-assessment.other" },
        ].map((item) => (
          <Grid key={item.name} md={2} xs={6}>
            <ByzTitleAndInputBox marginLeft="0px" title={t(item.label)}>
              <Controller
                name={item.name}
                control={control}
                render={({ field }) => (
                  <ByzMuiTextField {...field} sx={{ pt: 1 }} />
                )}
              />
            </ByzTitleAndInputBox>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
